export const LANGUAGE_ORIGIN = "https://vvpsstaxiservices.com";
export function languageOf(path = "/") { return /^\/hi(?:\/|$)/.test(path) ? "hi" : "en"; }
export function englishPath(path = "/") { const value = path.replace(/^\/hi(?=\/|$)/, ""); return value || "/"; }
export function languagePath(path = "/", language = "en") { const value = englishPath(path); return language === "hi" ? "/hi" + (value === "/" ? "/" : value) : value; }
export function languageURL(url, language = "en") {
    if (!url) return url;
    try { const parsed = new URL(url, LANGUAGE_ORIGIN); if (parsed.origin !== LANGUAGE_ORIGIN) return url; parsed.pathname = languagePath(parsed.pathname, language); return parsed.href; } catch { return url; }
}
export function dictionaryGroup(path = "/") {
    const clean = englishPath(path).split(/[?#]/)[0];
    const city = clean.match(/^\/(?:taxi-service-|tempo-traveller-rental-)([^/]+)/);
    if (city) return "city-" + city[1];
    if (clean.startsWith("/destinations/")) { const state = clean.split("/")[2]; return state && state !== "page" ? "directory-" + state : "directory"; }
    return "general";
}
